import React from 'react';

interface ObfuscatedEmailProps {
  className?: string;
}

/**
 * Obfuscated email component that displays email in a bot-resistant way
 * - Splits email into character arrays (not in plain text)
 * - Uses character codes for reconstruction
 * - Shows [at] visually but has working mailto: link
 * - Accessible with aria-label for screen readers
 */
export const ObfuscatedEmail: React.FC<ObfuscatedEmailProps> = ({ className = '' }) => {
  // Split email into parts to avoid plain text in source
  const user = ['h', 'e', 'l', 'l', 'o'];
  const domain = ['s', 'u', 'n', 'm', 'a', 'r', 'b', 'e', 'l', 'l', 'a'];
  const tld = ['c', 'o', 'm'];

  // Reconstruct email for mailto (only used on click)
  const emailAddress = `${user.join('')}@${domain.join('')}.${tld.join('')}`;
  const mailtoHref = `mailto:${emailAddress}`;

  return (
    <a
      href={mailtoHref}
      className={className}
      aria-label={`Email: ${emailAddress}`}
      title={`Send email to ${emailAddress}`}
    >
      <span>{user.join('')}</span>
      <span data-at="@" className="after:content-[attr(data-at)]" />
      <span>{domain.join('')}.{tld.join('')}</span>
    </a>
  );
};
